// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"SectionVideo_TheComp__tksyY"};